import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, FlexBox } from '@dixa/lib-shared-habla';
import { ContactsSidebarTop } from './components/top/contactsSidebarTop';
export function ContactsSidebar({ children }) {
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", height: "100%" }, { children: [_jsx(ContactsSidebarTop, {}), _jsx(Column.Row, Object.assign({ scrollable: true, size: 1, noHorizontalPadding: true, noVerticalPadding: true }, { children: children }))] })));
}
